import {
  IsBoolean,
  IsDateString,
  IsIn,
  IsNumber,
  IsOptional,
  IsString,
  MaxLength,
  Min,
} from 'class-validator';
import { MEASUREMENT_UNITS, type MeasurementUnit } from '../../label/measurement-unit';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import {
  RECALL_NOTICE_CHANNELS,
  RECALL_NOTICE_STATUSES,
  type RecallNoticeChannel,
  type RecallNoticeStatus,
} from './recall.enums';

export class UpdateRecallPartyDto {
  @IsIn(RECALL_NOTICE_STATUSES)
  @IsOptional()
  noticeStatus?: RecallNoticeStatus;

  @IsIn(RECALL_NOTICE_CHANNELS)
  @IsOptional()
  noticeChannel?: RecallNoticeChannel;

  /** ISO date-time; se assente e noticeStatus passa a NOTIFIED, il backend usa now(). */
  @IsDateString()
  @IsOptional()
  notifiedAt?: string;

  @IsBoolean()
  @IsOptional()
  acknowledged?: boolean;

  @IsString()
  @IsOptional()
  @MaxLength(2000)
  @OptionalStringTransform()
  notes?: string;

  /**
   * Quantità consegnata a questa parte. `null` la cancella. Deve arrivare
   * insieme a `quantityUnit` (o con l'unità già presente sulla parte): il
   * backend rifiuta con 400 un valore senza unità risolvibile.
   */
  @IsOptional()
  @IsNumber({ maxDecimalPlaces: 2 })
  @Min(0)
  quantity?: number | null;

  @IsOptional()
  @IsIn(MEASUREMENT_UNITS)
  quantityUnit?: MeasurementUnit | null;
}
